import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

import { StudentFeatureService } from '../services/student-feature.service';

/**
 * Ferme un écran de l'espace élève que son pack n'ouvre pas.
 *
 * <p>La route déclare sa fonctionnalité dans `data.feature` (`'library'`,
 * `'agenda'`…), la même clé que l'entrée de menu et que
 * `[RequireStudentFeature]` côté serveur. Une adresse tapée à la main mène au
 * tableau de bord plutôt qu'à un écran dont chaque appel répondrait 403.</p>
 */
@Injectable({ providedIn: 'root' })
export class StudentFeatureGuard implements CanActivate {
  private readonly features = inject(StudentFeatureService);
  private readonly router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const feature = route.data['feature'] as string | string[] | undefined;
    if (!feature) return true;

    await this.features.load();
    return this.features.allows(feature) || this.router.createUrlTree(['/student/dashboard']);
  }
}
